import { render } from "./DraggableCaption.vue?vue&type=template&id=14e61478&scoped=true"
import script from "./DraggableCaption.vue?vue&type=script&lang=js"
export * from "./DraggableCaption.vue?vue&type=script&lang=js"

import "./DraggableCaption.vue?vue&type=style&index=0&id=14e61478&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e61478"]])

export default __exports__